/* eslint no-console: 0 */
// Word search takes at most 255 characters
export const MAX_SEARCH_LENGTH = 255;

export function truncateToWordBoundary(text: string, max: number): string {
  const trimmed = text.replace(/\s+/g, " ").trim();
  if (trimmed.length <= max) {
    return trimmed;
  }
  const cut = trimmed.substring(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return lastSpace > 0 ? cut.substring(0, lastSpace) : cut;
}

export const SEARCH_OPTIONS = {
  matchCase: false,
  matchWholeWord: false,
  ignoreSpace: true,
};

// Plain search first; ignorePunct fallback bridges line-wrap hyphens
export async function searchRange(
  context: Word.RequestContext,
  scope: Word.Body | Word.Range,
  searchText: string,
): Promise<Word.Range[]> {
  const plain = scope.search(searchText, SEARCH_OPTIONS);
  plain.load("items");
  await context.sync();
  if (plain.items.length > 0) {
    return plain.items;
  }
  const loose = scope.search(searchText, {
    ...SEARCH_OPTIONS,
    ignorePunct: true,
  });
  loose.load("items");
  await context.sync();
  if (loose.items.length > 0) {
    console.log(
      `searchRange: Found ${loose.items.length} results ignoring punctuation`,
    );
  }
  return loose.items;
}

export async function searchInDocument(
  context: Word.RequestContext,
  searchText: string,
): Promise<Word.Range[]> {
  if (typeof searchText !== "string") {
    console.error(
      `searchInDocument: Invalid search text type: ${typeof searchText}, value:`,
      searchText,
    );
    throw new Error(
      `Invalid search text type: expected string, got ${typeof searchText}`,
    );
  }

  if (!searchText || searchText.trim().length === 0) {
    console.log(
      "searchInDocument: Empty search text provided, returning empty results",
    );
    return [];
  }

  const trimmedSearch = searchText.trim();

  if (trimmedSearch.length < 2) {
    console.log(
      `searchInDocument: Search text too short (${trimmedSearch.length} chars), returning empty results`,
    );
    return [];
  }

  try {
    const body = context.document.body;
    const items = await searchRange(context, body, trimmedSearch);

    console.log(
      `searchInDocument: Found ${
        items.length
      } results for "${trimmedSearch.substring(0, 50)}..."`,
    );

    return items;
  } catch (error) {
    console.log(
      `searchInDocument: Error searching for "${searchText}":`,
      error,
    );
    throw new Error(
      `Failed to search for text "${searchText.substring(0, 50)}...": ${
        error instanceof Error ? error.message : "Unknown error"
      }`,
    );
  }
}
